import _ from "lodash";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import React from "react";
import classes from "./SubjectViewOnly.scss";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Tooltip, Button } from "@toddle-edu/ds-web";
import { getLabelWithArchivedText } from "Utils";
import { compose } from "lib/apolloClient";

class SubjectViewOnly extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  renderEdit = () => {
    const { value, options, t, styles } = this.props;
    const subject = _.find(options, option => _.includes(value, option.id));
    const isArchived = _.get(subject, "isArchived", false);
    const label = _.get(subject, "name", "");

    return (
      <div className={classes.container} style={styles}>
        <Tooltip tooltip={t("unitPlan:disable_label_dp")} showArrow={true}>
          <Button
            dsVersion="2.0"
            variant="neutral"
            type="plain"
            disabled={true}
            size="small"
            className={classes.singlePageButton}
          >
            <div className={classNames("text-body", classes.subjectLabel)}>
              {getLabelWithArchivedText({
                t,
                label,
                isArchived,
              })}
            </div>
          </Button>
        </Tooltip>
      </div>
    );
  };

  renderView = () => {
    const { options, t, value, styles } = this.props;

    const subject = _.find(options, option => _.includes(value, option.id));

    const isArchived = _.get(subject, "isArchived", false);
    const label = _.get(subject, "name", "");

    return (
      <div className={classes.viewSubjectContainer} style={styles}>
        <div className={classNames("text-body", classes.subjectLabel)}>
          {getLabelWithArchivedText({
            t,
            label,
            isArchived,
          })}
        </div>
      </div>
    );
  };
}

SubjectViewOnly.defaultProps = {
  ...UIBaseComponent.defaultProps,
  value: [],
};

SubjectViewOnly.propTypes = {
  ...UIBaseComponent.propTypes,
  value: PropTypes.array,
};

export default compose(I18nHOC({ resource: ["common"] }))(SubjectViewOnly);
